var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"navigation-tabs"},[_c('div',{staticClass:"navigation-tabs-container"},_vm._l((_vm.tabs),function(tab,index){return _c('router-link',{key:index,staticClass:"route-nav-link",class:_vm.selectedTabClass(tab),attrs:{"to":tab}},[_vm._v(_vm._s(tab.text))])}),1),_c('div',{staticClass:"bottom-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }